<div class="root">
  <label [for]="inputId" class="label" [class.clickable]="isClickable">
    {{ inputName }}<span *ngIf="mandatory" class="mandatory-indicator"> *</span>
  </label>

  <ng-container *ngIf="helpTooltipText">
    <div class="tooltip-icon" ngxTippy [attr.data-tippy-content]="helpTooltipText" [tippyProps]="tippyProps">
      <app-lucide-icon [iconName]="'circle-help'" [size]="16" [color]="'darkGray'"></app-lucide-icon>
    </div>
  </ng-container>
</div>